var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinebottomrightbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1913,
    height: 496,
    viewBox: "0 0 1913 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.96 480.035H1570.05L1599.3 464.364L1596.77 459.622V459.63L1568.74 474.645H1355.96V480.035Z",
    fill: "#125D60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1482.45 468.655H1557.37V461.484H1482.45V468.655Z",
    fill: "#01FFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1447.05 471.439H1451.88V454.513H1447.05V471.439Z",
    fill: "#01FFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1437.39 471.439H1442.22V454.513H1437.39V471.439Z",
    fill: "#01FFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1456.73 471.439H1461.56V454.518H1456.73V471.439Z",
    fill: "#01FFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1513.12 455.865H1718.19V448.691H1513.12V455.865Z",
    fill: "#125D60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1871.35 165.932H1891.76V163.232H1871.35V165.932Z",
    fill: "#01FFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1871.35 180.781H1891.76V178.081H1871.35V180.781Z",
    fill: "#01FFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1871.35 173.297H1891.76V170.597H1871.35V173.297Z",
    fill: "#01FFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1871.35 158.426H1891.76V155.721H1871.35V158.426Z",
    fill: "#01FFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1878.97 137.351L1903.52 167.007V241.479H1910.27V164.6L1885.72 134.941V89.3809H1878.97V137.351Z",
    fill: "#01FFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1630.72 433.127H1761.12V427.062L1761.14 427.054H1799.91L1891.97 334.998V183.47H1868.37V191.77H1874.15V294.036H1868.37V325.231L1790.12 403.47H1734.31V421.88H1630.72V433.127Z",
    fill: "#125D60"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1851.98 65.8049H1854.3V0.836914H1851.98V65.8049Z",
    fill: "#125D60"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1900.77 421.486H1912.03V260.923H1900.77V421.486Z",
    fill: "#125D60"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.718 464.363L340.969 480.035H984.201V474.645H342.274L314.248 459.631V459.621L311.718 464.363Z",
    fill: "#125D60"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1046.04 495.328H1066.28V463.777H1046.04V495.328Z",
    fill: "#01FFFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1078.95 495.328H1099.19V463.777H1078.95V495.328Z",
    fill: "#01FFFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1111.83 495.328H1132.08V463.777H1111.83V495.328Z",
    fill: "#01FFFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.72 495.328H1164.96V463.777H1144.72V495.328Z",
    fill: "#01FFFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1177.6 495.328H1197.85V463.777H1177.6V495.328Z",
    fill: "#01FFFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1210.48 495.328H1230.73V463.777H1210.48V495.328Z",
    fill: "#01FFFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1243.4 495.328H1263.64V463.777H1243.4V495.328Z",
    fill: "#01FFFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.28 495.328H1296.53V463.777H1276.28V495.328Z",
    fill: "#01FFFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1309.17 495.328H1329.41V463.777H1309.17V495.328Z",
    fill: "#01FFFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1013.15 495.328H1033.4V463.777H1013.15V495.328Z",
    fill: "#01FFFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.812 455.865H397.883V448.691H192.812V455.865Z",
    fill: "#01FFFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.65 468.655H428.566V461.484H353.65V468.655Z",
    fill: "#125D60"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.102 471.439H463.946V454.513H459.102V471.439Z",
    fill: "#125D60"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.789 471.439H473.623V454.513H468.789V471.439Z",
    fill: "#125D60"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.447 471.439H454.28V454.513H449.447V471.439Z",
    fill: "#125D60"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2539 165.603H39.6599V162.902H19.2539V165.603Z",
    fill: "#01FFFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2539 180.781H39.6599V178.081H19.2539V180.781Z",
    fill: "#01FFFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2539 158.217H39.6599V155.517H19.2539V158.217Z",
    fill: "#01FFFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8516 123.652H18.2296V68.866H14.8516V123.652Z",
    fill: "#01FFFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.732422 241.484H7.46742V167.016L32.0174 137.357V38.8379H25.2824V134.938L0.732422 164.6V241.484Z",
    fill: "#125D60"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.04 337.087L111.103 429.145H149.866L149.884 429.155V435.222H280.284V423.974H176.705V405.564H120.876L42.634 327.324V296.13H36.855V193.862H42.634V185.562H19.04V337.087Z",
    fill: "#125D60"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2539 173.297H39.6599V170.597H19.2539V173.297Z",
    fill: "#01FFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinebottomrightbox);
export default __webpack_public_path__ + "static/media/linebottomrightbox.ad6d44d963609c94de6d0144181e112d.svg";
export { ForwardRef as ReactComponent };